<template>
  	<b-row align-v="center" class="login-cover-caption">

		<b-col align-self="center" cols="3" style="max-width: 320px">
		
			<img src="/img/login/login-logo.png" 
				 class="form-signin-heading" 
				 alt="Май" />
		
			<b-row class="mb-15">

				<b-form-input type="text"
							  v-model="email"
							  placeholder = "Логин"
							  @keyup.enter="login" />
			</b-row>

			<b-row class="mb-15">

				<b-form-input type="password"
							  v-model="password"
							  placeholder = "Пароль" 
							  @keyup.enter="login"/>
			</b-row>

			<button class="btn btn-lg btn-success btn-block medium" 
					type="submit" 
					@click="login">

				Войти
			</button>

			<b-row class="m-0 forgot-password-row">
				<router-link :to="forgotPasswordLink" class="forgot-password-link">ЗАБЫЛИ ПАРОЛЬ?</router-link>
			</b-row>

		</b-col>

  	</b-row>

</template>

<script>

import { ACCOUNT_LOGIN } from "@/store/actions.type";
import allRoutes from '@/routes/all.routes';
import dialogService from '@/services/dialog.service';

export default {
	name: "AccountLogin",
	props: {},
	data: function() {

		return {
			email: "",
			password: "",

			forgotPasswordLink: allRoutes.Account.ForgotPassword
		}
	},
	methods: {
		login: function() {
			if(!this.email) {
				dialogService.showAlert('Предупреждение', 'Введите логин');
				return;
			}

			if(!this.password) {
				dialogService.showAlert('Предупреждение', 'Введите пароль');
				return;
			}

			let loginInfo = {
				Email: this.email,
				Password: this.password
			};

			this.$store.dispatch(ACCOUNT_LOGIN, loginInfo)
				.then(response => {
					this.$router.push(allRoutes.Client.Feed);					
				})
				.catch(exception => { });
		}
	}
};
</script>
